import { TDraftRoutes, TFilters } from './types';

const paths = {
  home() {
    return '/';
  },
  addNewTour() {
    return '/tour/add-new';
  },
  draft(draftId: string, pathname: TDraftRoutes) {
    return `/draft/${draftId}/${pathname}`;
  },
  terms() {
    return '/terms-and-conditions';
  },
  privacy() {
    return '/privacy-policy';
  },
  categoryShow(slug: string) {
    return `/category/${slug}`;
  },
  tourAvailability(tourId: string, queryString: string) {
    return `/tours/${tourId}?${queryString.toString()}`;
  },
  tourShow(tourId: number) {
    return `/tours/${tourId}`;
  },
  search() {
    return '/search';
  },
  searchActivity(filters: TFilters) {
    const params = new URLSearchParams();
    for (const [filter, value] of Object.entries(filters)) {
      params.set(filter, value.toString());
    }
    return `/search?${params}`;
  },
};

export default paths;
